import { render } from "./SquadStatus.vue?vue&type=template&id=9535d9d8&scoped=true"
import script from "./SquadStatus.vue?vue&type=script&lang=js"
export * from "./SquadStatus.vue?vue&type=script&lang=js"

import "./SquadStatus.vue?vue&type=style&index=0&id=9535d9d8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9535d9d8"]])

export default __exports__